// ReviewsIo Scroll Offset
document.addEventListener('click', function(e) {
  const ratingSnippet = e.target.closest('.ruk_rating_snippet');
  if (ratingSnippet) {
    e.preventDefault();
    e.stopPropagation();
    
    const target = document.querySelector('reviewsio-product-reviews-widget');
    if (target) {
      const offset = window.innerHeight * 0.2;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  }
}, true); 